import React, { Component } from 'react'
import PropTypes from 'prop-types'

import NoQuestsAssignedToYou from '../../mini/NoQuestsAssignedToYou'
import DesignANewQuest from '../../mini/DesignANewQuest'

export default class NoQuests extends Component {
  render() {
    const { section } = this.props
    return <div className={`no-quests ${section}`}>{this.renderContent()}</div>
  }

  renderContent() {
    const { section } = this.props
    let retVal = null

    switch (section) {
      case 'assignments': {
        retVal = <NoQuestsAssignedToYou />
        break
      }
      case 'drafts': {
        retVal = (
          <div>
            <span>You have no quests in draft yet. Click on</span>
            <DesignANewQuest addQuest={this.props.addQuest} />
            <span>to begin!</span>
          </div>
        )
        break
      }
      case 'inQualityReview': {
        retVal = (
          <span>
            You have no quests in publication review yet. Keep working!
          </span>
        )
        break
      }
      case 'published': {
        retVal = <span>You have no published quests yet. Keep working!</span>
        break
      }
    }

    return retVal
  }
}

NoQuests.propTypes = {
  section: PropTypes.string.isRequired,
  addQuest: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/myquests/myquests/NoQuests.js